import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectService } from './../../services/project.service';
import { ToastrService } from "ngx-toastr";
import { SharedDataService } from 'src/app/core-features/shared/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss'],
})
export class CreateProjectComponent implements OnInit{
  public model:any={}
  private submitting: boolean = false;
  isDelete = false;
  tags: any = [];
  public type: string;

  public projectForm: FormGroup = this._FormBuilder.group({
    id: new FormControl(null),
    name: ["", Validators.required],
    tags: [""],
    description: [""],
    isActive: ["true"]
  });

  constructor( 
    public dialogRef: MatDialogRef<CreateProjectComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _FormBuilder: FormBuilder, 
    private projectDataService: ProjectService,
    private toastr: ToastrService,
    private SharedDataService: SharedDataService,
    private router: Router
  ) { 
      this.data.data;
      if (this.data.data != undefined) {
        let tags_output: any = [];
      
        if (this.data.data.tags != "" && this.data.data.tags != null) {
          let tags: any = this.data.data.tags.split(", ");

          tags.filter((item) => {
            tags_output.push({ displayValue: item });
          });
          this.tags = tags_output;
        }
      let Attribute = this.data.data; 
        this.projectForm.patchValue({
          id: Attribute["id"],
          name: Attribute["name"],
          tags: tags_output,
          description: Attribute["description"],
          isActive: Attribute["isActive"],
        });
  }
}

ngOnInit() {
  this.dialogRef.keydownEvents().subscribe(event => { //close modal on escap key
    if (event.key === "Escape") {
      this.onClose('unchanged'); //close dialog func
    }
  });
}

  addValue(str) {
    this.SharedDataService.updateComp1Val(str);
  }

  onSubmit() {
    if (this.projectForm.valid) {
      this.submitting = true;
      let Form = this.projectForm.value;
     
        let tags = "";
        if(this.projectForm.value.tags != "" || this.projectForm.value.tags.length != 0){
        Form.tags.filter((item) => {
          tags += item.displayValue + ", ";
        });
      }
        Form.tags = tags.slice(0, tags.length - 2);
     
      if (Form.id == null) {
        delete Form.id;
        
        this.projectDataService.create(Form).subscribe(
          (data) => {
            this.addValue(data["body"]);
            this.projectForm.reset({ isActive: true });
            this.submitting = false;
            this.projectForm.patchValue({ id: null });
            this.onClose('changed');
            this.toastr.success("", "Project Register Successfully!", {
              positionClass: 'toast-top-right' 
           });
          },
          (error) => {
            this.submitting = false;
            if (error.error.statusCode == 403) {
              this.toastr.error("", "Access denied");
            } else if (error.error.statusCode == 401) {
              this.router.navigate(['/auth/login']);
            } else if (error.error.statusCode == 0) {
              this.toastr.error("", "Something Went Wrong");
            } else {
              this.toastr.error("", error.error.message);
            }
          }
        );
      } else {
        let id = Form.id;
        delete Form.id;
        this.projectDataService.update(id, Form).subscribe(
          (data) => {
           this.toastr.success("", "Project updated Successfully!", {
              positionClass: 'toast-top-right' 
           });
            this.submitting = false;
            this.projectForm.patchValue({ id: id });
            this.onClose('changed');
          },
          (error) => {
            this.projectForm.patchValue({ id: id });
            this.submitting = false;
            if (error.error.statusCode == 403) {
              this.toastr.error("", "Access denied");
            } else if (error.error.statusCode == 401) {
              this.router.navigate(['/auth/login']);
            } else if (error.error.statusCode == 0) {
              this.toastr.error("", "Something Went Wrong");
            } else {
              this.toastr.error("", error.error.message);
            }
          }
        );
      }
    } else {
      Object.keys(this.projectForm.controls).forEach(key => {
        this.projectForm.controls[key].markAsTouched();
      });
      this.toastr.warning("", "Invalid form!");
    }
  }

  onClose(data:any) {
    if(data==undefined){
        data='unchanged'
    }
     this.dialogRef.close(data);
 }
}
